// ID,Парк,Количество машин,Руб км,Руб в час

const data = [
    [124229722, "Тент/Реф", "50 - 100", 148.45, 1317.91],
    [68473396, "Реф", "1 - 50", 107.57, 2099.29],
    [31161131, "Тент", "1 - 50", 88.98, 1794.34],
    [124229462, "Тент", "1 - 50", 88.44, 1739.13],
    [10904385, "Тент", "100+", 87.12, 1819.44],
    [13901106, "Тент/Реф", "1 - 50", 86.68, 1327.0],
    [86778583, "Бензовоз/Полуцистерна", "1 - 50", 85.96, 1522.72],
    [40803898, "Реф", "50 - 100", 85.82, 1700.17],
    [124229452, "Тент", "1 - 50", 84.18, 1636.21],
    [124229612, "Тент", "1 - 50", 82.87, 1069.97],
    [247, "Тент/Реф", "100+", 82.43, 1349.17],
    [124229643, "Тент/Реф", "1 - 50", 81.8, 1253.99],
    [124229442, "Тент/Реф", "50 - 100", 80.23, 1560.41],
    [76409545, "Тент", "1 - 50", 79.82, 1121.02],
    [10006450, "Реф", "100+", 79.72, 1505.36],
    [124229724, "Тент", "1 - 50", 78.34, 1542.44],
    [124229813, "Тент", "1 - 50", 78.31, 1013.44],
    [124229832, "Тент", "1 - 50", 78.26, 1605.84],
    [39703093, "Тент", "1 - 50", 75.81, 1318.4],
    [124229673, "Тент/Реф", "1 - 50", 75.59, 1905.16],
    [60252408, "Тент/Реф", "50 - 100", 74.74, 1926.58],
    [18690824, "Тент/Реф", "50 - 100", 74.67, 1148.25],
    [16624460, "Тент", "50 - 100", 73.75, 1914.26],
    [2578465, "Тент/Реф", "100+", 73.55, 1789.47],
    [100618972, "Тент/Реф", "100+", 73.4, 1984.02],
    [124229572, "Реф", "1 - 50", 73.17, 1518.08],
    [124229772, "Тент", "100+", 72.05, 1669.09],
    [49029268, "Тент/Реф", "100+", 71.81, 1808.73],
    [124229822, "Тент", "1 - 50", 71.34, 1397.19],
    [28344423, "Тент", "1 - 50", 71.32, 1301.84],
    [124229632, "Реф", "1 - 50", 71.29, 1596.98],
    [124229682, "Тент/Реф", "1 - 50", 71.18, 1433.36],
    [124229302, "Тент", "100+", 70.67, 1726.21],
    [63782535, "Тент", "50 - 100", 70.52, 1377.62],
    [124229202, "6 т", "1 - 50", 70.3, 772.56],
    [59401, "Тент", "50 - 100", 70.27, 1068.32],
    [4847, "Тент/реф", "100+", 70.07, 1627.35],
    [124229552, "Тент", "50 - 100", 69.72, 1197.34],
    [124229502, "Тент/Реф", "1 - 50", 69.68, 1189.51],
    [107567048, "Тент", "1 - 50", 69.43, 1414.05],
    [215, "Тент", "50 - 100", 68.51, 1232.53],
    [124229702, "Тент/Реф", "1 - 50", 68.28, 1277.26],
    [9716809, "Тент/Реф", "100+", 68.27, 1480.25],
    [9885748, "Тент", "1 - 50", 68.26, 1165.01],
    [113868730, "Тент/Контейнеровоз/Трал/Борт", "100+", 68.2, 808.09],
    [76328364, "Тент", "100+", 67.76, 1558.8],
    [124229792, "Тент/Реф", "50 - 100", 67.6, 1033.82],
    [124229542, "Тент", "1 - 50", 67.52, 1045.1],
    [72333529, "Тент", "50 - 100", 66.96, 1695.7],
    [87027013, "Тент", "100+", 66.89, 1722.9],
    [51939223, "Тент/Реф", "100+", 66.87, 1559.83],
    [11250940, "Тент/Реф", "100+", 66.82, 1626.9],
    [124229782, "Тент/Шаланда", "1 - 50", 66.79, 1082.31],
    [123066101, "Тент/Реф", "100+", 66.23, 1496.5],
    [124229392, "Тент", "50 - 100", 65.94, 885.6],
    [106815204, "Тент/Реф", "100+", 65.21, 919.34],
    [124229332, "Реф", "1 - 50", 64.72, 1442.0],
    [124229472, "Тент/Реф", "1 - 50", 64.47, 964.83],
    [50875631, "Тент", "1 - 50", 64.26, 1152.75],
    [124229192, "Тент", "1 - 50", 64.21, 882.9],
    [124229522, "Тент", "100+", 63.78, 1106.78],
    [124229443, "Тент/Автоцистерна", "1 - 50", 63.1, 1139.37],
    [111645679, "Тент/Реф", "1 - 50", 63.07, 1537.99],
    [2967831, "Тент/Реф", "100+", 62.4, 927.2],
    [124229432, "Тент", "1 - 50", 62.33, 1574.45],
    [124229623, "Тент", "50 - 100", 61.44, 1037.39],
    [124229672, "Тент", "1 - 50", 61, 1172.0],
    [124229282, "Тент", "1 - 50", 60.6, 1342.05],
    [203, "4-ех осный полуприцеп", "100+", 60.55, 750.23],
    [558126, "Реф", "100+", 60.45, 1428.88],
    [109115434, "Тент", "1 - 50", 60.35, 991.43],
    [220, "Контейнеровоз/Цементовоз/Стекловоз", "50 - 100", 58.88, 1047.94],
    [124229802, "Тент", "1 - 50", 57.89, 1081.08],
    [124229292, "Тент/Реф", "1 - 50", 56.42, 1048.01],
    [124229692, "Тент/Реф", "1 - 50", 54, 918.0],
    [124229653, "Тент", "1 - 50", 48.37, 758.14],
    [124229342, "Тент/Реф", "1 - 50", 47.02, 835.49],
    [103974599, "Тент", "1 - 50", 42.92, 742.01],
    [124229752, "Тент", "1 - 50", 42.59, 1019.19],
    [50340085, "3.5 т", "1 - 50", 35.49, 489.35],
    [48735614, "Контейнеровоз", "1 - 50", 32.76, 445.55],
    [102891670, "Тент/Реф", "1 - 50", 24.27, 791.03],
];

export default data.sort((a, b) => b[4] - a[4]);
